import React from 'react'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMBIOS_CEREAL_EXPORTADOR } from '../../../config/tables'

export default function CambiosDeCerealExportadorView () {
  return <MuiTable id={TABLA_CAMBIOS_CEREAL_EXPORTADOR} />
}
